// extracted by mini-css-extract-plugin
export default {"errorOuterBody":"error_errorOuterBody__TxdgZ","errorBody":"error_errorBody__-Ch8Q","homeLink":"error_homeLink__0poSw"};